export enum AudioType {
    DiceRoll1, DiceRoll2, DiceRoll3, DiceRoll4, YourTurn, FirstReminder,
    RoadPlace, SettlementPlace, CityPlace, ShipPlace, ShipMove, MetropolisPlace, CityWallPlace, CityDestroy, CityImprovement,
    RobberPlace, PiratePlace,
    LeaveRoom, JoinRoom, RoomSettingUpdated, RoomGetReady,
    ClockTick, MessageNotification, Click, Victory, VoteReminder, AchievementCKProgress, GameStarted, GameStartedGuitar, AchievementLargestArmy, AchievementLongestRoad, SettlementPhaseEnded, SettlementPhaseEndedGuitar,
    OfferAcceptable, OfferNotAcceptable, OfferAccepted, OfferRejected, Reconnect, Disconnect, KnightEquip, KnightPlace, KnightUpgrade, DiscardBroadcast, DiscardNotification,
    BeginnerHintActivated, DevelopmentCardBought, DevelopmentCardMonopoly, DevelopmentCardUsed
}
